import { FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const EngineInfo = () => {
  const {
    register,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useFormContext();
  const [enableChainedModels, setEnableChainedModels] = useState(getValues('enableChainedModels'));
  const [modelOwnerPaysForInference, setModelOwnerPaysForInference] = useState(getValues('modelOwnerPaysForInference'));

  const onToggleChange = (fieldName, event) => {
    const value = event.target.checked;
    if (fieldName === 'enableChainedModels') {
      setEnableChainedModels(value);
    } else if (fieldName === 'modelOwnerPaysForInference') {
      setModelOwnerPaysForInference(value);
    }
    setValue(fieldName, value);
  };

  return (
    <>
      <Grid item container spacing={2}>
        <Grid item xs={12} lg={12}>
          <TextField
            fullWidth
            label="Engine Name"
            variant="outlined"
            size="small"
            disabled={false}
            placeholder="Enter Engine Name"
            {...register('engineName', { required: true })}
            error={Boolean(errors['engineName'])}
            // required
            inputProps={{
              maxLength: 250,
            }}
            helperText={errors['engineName'] ? 'Engine Name is required' : ''}
          ></TextField>
        </Grid>
        <Grid item xs={12} lg={12}>
          <TextField
            fullWidth
            label="Engine Description"
            variant="outlined"
            size="small"
            disabled={false}
            placeholder="Enter Engine Description"
            {...register('engineDescription', { required: false })}
            multiline
            minRows={7}
            maxRows={8}
          ></TextField>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Memory Requirement"
            variant="outlined"
            size="small"
            disabled={false}
            placeholder="Enter Memory Requirement"
            {...register('memoryRequirement', { required: true })}
            error={Boolean(errors['memoryRequirement'])}
            // required
            type='number'
            inputProps={{
              inputProps: { min: 1000, max: 10000 },
            }}
            helperText={errors.memoryRequirement?.message}
          ></TextField>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Storage Requirement"
            variant="outlined"
            size="small"
            disabled={false}
            placeholder="Enter Storage Requirement"
            {...register('storageRequirement', { required: true })}
            error={Boolean(errors['storageRequirement'])}
            // required
            inputProps={{
              inputProps: { min: 1000, max: 10000 },
            }}
            helperText={errors.storageRequirement?.message}
          ></TextField>
        </Grid>
        <Grid item xs={12} md={6}>
            <Controller
              name="enableChainedModels"
              control={control}
              render={({ field: { onChange, value } }) => (
                <FormControlLabel
                  sx={{ ml: 0 }}
                  control={<Switch size="small" checked={value} onChange={onChange} />}
                  label="Enable Chained Models"
                  labelPlacement="start"
                />
              )}
            />
        </Grid>
      </Grid>
    </>
  );
};

export default EngineInfo;
